import React, { memo } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { SpotifyLogo } from './SpotifyLogo';
import { useAuth } from '@/hooks/useAuth';

interface IHeaderProps {
    theme: string;
    toggleTheme: () => void;
}

export const Header = memo(({ theme, toggleTheme }: IHeaderProps) => {
    const location = useLocation();
    const isAdmin = location.pathname.startsWith('/admin');
    const { user } = useAuth();
    return (
        <header className="sticky top-0 z-10 w-full mb-4">
            <div className="topbar flex items-center justify-between px-4 py-2">
                <Link to="/" className="flex items-center gap-2 focus:outline-none focus:ring-2 focus:ring-[#1DB954] rounded-md">
                    <SpotifyLogo size={24} />
                    <span className="font-bold text-white hidden sm:block">Spotify Global</span>
                </Link>
                <div className="flex-1 flex items-center justify-center px-4">
                    <div className="relative w-full max-w-2xl">
                        <i className="ph ph-magnifying-glass absolute left-3 top-1/2 -translate-y-1/2 text-zinc-300 pointer-events-none"></i>
                        <input
                          type="text"
                          placeholder="Pesquisar (Ctrl + K)"
                          className="searchbar w-full pl-10 pr-4 py-2 rounded-md outline-none"
                        />
                    </div>
                </div>
                <div className="flex items-center gap-2">
                    <button
                        onClick={toggleTheme}
                        className="icon-btn"
                        aria-label="Alternar tema"
                    >
                        {theme === 'dark' ? <i className="ph-fill ph-sun text-yellow-300"></i> : <i className="ph-fill ph-moon text-white"></i>}
                    </button>
                    <button className="icon-btn" aria-label="Notificações">
                        <i className="ph ph-bell text-white"></i>
                        <span className="absolute top-1 right-1 block h-2 w-2 rounded-full bg-red-500"></span>
                    </button>
                    <Link to="/settings" className="flex items-center gap-2 group p-1 rounded-full hover:bg-white/10 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#1DB954]">
                        <img src={user?.avatarUrl || 'https://placehold.co/32x32/1DB954/FFFFFF?text=I'} alt="Avatar" className="w-8 h-8 rounded-full" />
                        <span className="hidden md:block text-white text-sm font-semibold">{user?.name || user?.email || 'Usuário'}</span>
                    </Link>
                </div>
            </div>
        </header>
    );
});

export default Header;
